'use es6';

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types'; // Based off code from marketing-orchestration-ui

function ExternalScript({
  id,
  src,
  async = true
}) {
  const [installed, setInstalled] = useState(false);
  useEffect(() => {
    if (installed) {
      return;
    }

    const scriptEl = document.createElement('script');
    scriptEl.id = id;
    scriptEl.src = src;
    scriptEl.async = async;
    document.head.appendChild(scriptEl);
    setInstalled(true);
  }, [id, src, async, installed]);
  return null;
}

ExternalScript.propTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  async: PropTypes.bool
};
export default ExternalScript;